<template>
  <div id="app">

      <el-main>
        <router-view @checkLogin="checkLogin"/>
      </el-main>

    <Login ref="login" @loginSuccess="loginSuccess"></Login>
  </div>

</template>

<script>

import Login from './LoginModal';

export default {
  name: 'AppImage',
  data() {
    return {
      login: false
    }
  },
  created: function () {

    const token = localStorage.getItem("token");
    this.login = token != null && token != "";

    if (this.login) {
      //this.getUserInfo();
    }
  },
  components: {
    Login,
  },
  methods: {
    loginSuccess: function () {
      this.login = true;
      //this.getUserInfo();
    },
    checkLogin: function () {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$refs.login.init()
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style>

</style>
